import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=40a4a8df&scoped=true&"
import script from "./UserOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=40a4a8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4a8df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VContainer,VImg,VRow,VSlider})
